<template>
  <el-dialog
    class="edit-user-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :append-to-body="true"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="username">
        <el-input v-model="editForm.username" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="editForm.email" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="editForm.phone" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'EditUser', 
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    let validatePwd = (rule, value, callback) => {
      if (value === this.editForm.md5Password) {
        callback()
      } else {
        callback(new Error('请保持输入密码一致'))
      }
    }
    let isValidate = (rule, value, callback) => {
      if (this.isEdit) {
        callback()
      } else {
        if (value !== '') {
          callback()
        } else {
          callback(new Error('请输入密码'))
        }
      }
    }
    return {
      title: '编辑用户信息',
      dialogVisible: false,
      editRule: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: '请输入合法手机号/电话号',
            trigger: 'blur'
          }
        ]
      },
      editForm: {
        username: '',
        email: '',
        phone: ''
      },
      info: {},
      adaptationVars: {
        formLabelWidth: 80
      }
    }
  },
  methods: {
    handleOpen(data) {
      this.$apis.system.getUserInfo({ id: data.ID }).then(res => {
        if (res.data) {
          this.info = res.data
          let obj = Object.keys(this.editForm)
          obj.map(ele => {
            this.editForm[ele] = res.data[ele]
          })
          this.dialogVisible = true
        }
      })
    },
    handleCancel() {
      this.editForm = {
        username: '',
        email: '',
        phone: ''
      }
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          let param = {
            id: this.info.id,
            email: this.editForm.email,
            phone: this.editForm.phone,
            roleId: this.info.roleId,
            status: this.info.status,
            username: this.editForm.username
          }
          this.$apis.system.reviseUser(param).then(res => {
            if (res) {
              this.$message.success('编辑用户成功,请重新登录！')
              this.handleCancel()
            }
          })
        } else {
          this.$message.warning('请完善信息')
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('edit-user-dialog', (), ());
.edit-user-dialog.common-dialog {
  @include adaptation((
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
